import React from "react";
import { Badge, Container } from "react-bootstrap";
import "./NavPanel.scss";
import { connect, useSelector } from "react-redux";
import { UserRole } from "../../Const";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { canAccessAssistant } from "../../utils/AssistantAccess";


const NavPanel = (props) => {
  const { selectedCom, onSelectCom,t } = props;
  const user = useSelector((state) => state.auth.user);
  const assistantEnabled = canAccessAssistant(user);
  const links = [
    {
      loc: 0,
      name: t("general"),
      icon: "general",
    },
    {
      loc: 1,
      name: t("account"),
      icon: "account",
    },
    {
      loc: 2,
      name: t("subscription"),
      icon: "subscription",
    },
  
    {
      loc: 3,
      name: t("exch-api"),
      icon: "exchange",
    },
    {
      loc: 4,
      name: t("formula"),
      icon: "formula",
    },
    {
      loc: 5,
      name: t("paper-wallet"),
      icon: "wallet",
    },
    {
      loc: 6,
      name: t("security"),
      icon: "security",
    },
    {
      loc: 7,
      name: t("notifications"),
      icon: "notification",
    },
    {
      loc: 8,
      name: t("request-symbols"),
      icon: "exchange",
    },
    {
      loc: 9,
      name: t("mcp"),
      icon: "mcp",
      assistantOnly: true,
    },
    {
      loc: 10,
      name: t("developer-api-title"),
      icon: "exchange",
    },
  ].filter((item) => !item.assistantOnly || assistantEnabled);
  const history = useHistory();
  const clickLink = (e, index) => {
    e.preventDefault();
    history.push(`/setting?loc=${index}`);
    onSelectCom(index);
  };
  const isActive = (i) => {
    return i === selectedCom ? "sn-active" : "";
  };
  const linkItems = links.map((item) => {
    return (
      <li key={item.loc} >
        <Link
          className={isActive(item.loc)}
          to={'/setting?loc='+item.loc}
          onClick={(e) => clickLink(e, item.loc)}
        >
          <img src={`/images/settings/${item.icon}.svg`}/>
          {item.name}
        </Link>
      </li>
    );
  });
  return (
    <div className="setting-nav-item">
				<ul>
         {linkItems}
         </ul>
    </div>
  );
};

export default connect(null)(NavPanel);
